// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__8uRBv","sidebar__icon":"Sidebar_sidebar__icon__evyqI","sidebar__show":"Sidebar_sidebar__show__lhJiI","sidebar__hide":"Sidebar_sidebar__hide__PKPyH"};